import client from '../httpClient';

const lineDeleteApi = (id) => {
  return client.delete(`/line-rooms/${id}`, { isShowMessage: true });
};

export default lineDeleteApi;
